<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.60042 4.49604C5.81398 4.75789 5.79892 5.14389 5.55484 5.38797L1.55484 9.38797C1.29449 9.64832 0.87248 9.64832 0.61214 9.38797C0.35179 9.12762 0.35179 8.70561 0.61214 8.44526L4.14078 4.91662L0.61214 1.38797C0.35179 1.12762 0.35179 0.705612 0.61214 0.445262C0.87248 0.184913 1.29449 0.184913 1.55484 0.445262L5.55484 4.44526L5.60042 4.49604Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChevronRightLargeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 12
    },
    fill: {
      type: String,
      default: '#8A8D93'
    }
  }
};
</script>
